import React from "react";

import { Link } from "react-router-dom";

const CVPage = () => {
  const AUTOMATION_MANAGER_PDF =
    "https://s3.us-east-1.amazonaws.com/www.fabrik-atlas.com-my-resumes/Cesar+JImenez+-+Automation+Manager+V2.0.pdf";

  const downloadFileAtUrl = () => {
    const url =
      "https://s3.us-east-1.amazonaws.com/www.fabrik-atlas.com-my-resumes/Cesar+JImenez+-+Automation+Manager+V2.0.pdf";
    window.location.href = url;
  };

  return (
    <>
      <h5>
        Please feel free to download my CV. You're downloading this file
        directly from an S3 Bucket from AWS.
      </h5>
      <Link to="#" onClick={downloadFileAtUrl}>
        Download
      </Link>
    </>
  );
};

export default CVPage;
